import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import SimpleInputField from '../SimpleTextField/SimpleTextField';
import * as EmailValidator from 'email-validator';
import ToggleButton from '../ToggleButton/ToggleButton';
import Button from '@material-ui/core/Button';

import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';

const styles = theme => ({
  root    : {
    flexGrow : 1,
    width    : '100%',
    margin   : 12,
  },
  paper   : {
    padding : 12,
  },
  control : {
    padding : theme.spacing.unit * 2,
  },
  title   : {
    fontSize : 24,
    margin   : 12,
  },
  button  : {
    margin : theme.spacing.unit,
  },
});

const validateEmailString = (email, allowEmpty = false) => {
  if (allowEmpty) {
    return !email || EmailValidator.validate(email);
  }
  return !EmailValidator.validate(email);
};

const TodoItem = ({ object, action, deleteAction, updateAction, classes, intl }) => (
  <TableRow>
    <TableCell className={classes.root}>
      <SimpleInputField
        id="title"
        required
        label={intl.formatMessage({ id: 'admin_todo_lists.title' })}
        data={object}
        action={action}
        required
      />
      <SimpleInputField
        id="description"
        required
        label={intl.formatMessage({ id: 'shared.description' })}
        data={object}
        action={action}
        required
      />
      <SimpleInputField id="image_name" label="Image Name" data={object} action={action} />
      <SimpleInputField
        id="thumbnail_name"
        label={intl.formatMessage({ id: 'admin_todo_lists.thumbnail_name' })}
        data={object}
        action={action}
      />
      <br />
      <div>
        <Button color="primary" href={`${object.id}/todo_item_questions/`} className={classes.button}>
          <FormattedMessage id="admin_todo_lists.view_questions" />
        </Button>
      </div>
    </TableCell>
    <TableCell>
      <IconButton
        color="primary"
        className={classes.button}
        aria-label="Save"
        disabled={!object.title || !object.modified}
        onClick={() => {
          updateAction(object);
        }}>
        <Icon>save</Icon>
      </IconButton>
      <IconButton className={classes.button} aria-label="Delete">
        <DeleteIcon
          onClick={() => {
            deleteAction(object);
          }}
        />
      </IconButton>
    </TableCell>
  </TableRow>
);

TodoItem.propTypes = {
  object       : PropTypes.object,
  action       : PropTypes.func.isRequired,
  deleteAction : PropTypes.func.isRequired,
  updateAction : PropTypes.func.isRequired,
  classes      : PropTypes.object.isRequired,
  intl         : PropTypes.object.isRequired,
};

TodoItem.defaultProps = {
  object : {},
};

const TodoItemWithStyle = withStyles(styles)(TodoItem);
export default injectIntl(TodoItemWithStyle);
